export default () => ({
  bookingFeeTypeList: [],
});
